import styled from 'styled-components';

import { media, rems, space } from '../ui/helpers';
import { SUB_MENU_HEIGHT } from '../ui/settings';
import { colors } from '..//ui/design-tokens';

const Main = styled.main`
  padding-top: 0;

  .bottomImage {
    background: ${colors.neutral[200]};
    position: relative;

    .image {
      position: relative;
      max-height: 350px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: end;

      img {
        height: initial;
        width: ${rems(410)};
        position: relative;
      }
    }
  }

  ${media.min('medium')`
    padding-top: ${rems(SUB_MENU_HEIGHT)};
    .bottomImage {
      padding-top: 0;
    }
  `}
`;

export default Main;
